import { createFileRoute, redirect } from '@tanstack/react-router';
import { FIX_ORDER_BASE_PATH } from '../../../../../../../../features/fix/order/fix-order-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/')({
  beforeLoad: () => {
    throw redirect({ to: FIX_ORDER_BASE_PATH });
  },
  preload: false,
});
